    <template>
        <div class="ele-body">
            <el-card shadow="never" body-style="padding-top: 5px;">
                <!-- 编辑弹窗 -->
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">

                    <el-form-item label="支付状态:" prop="pay_status">
                        <el-switch v-model="editForm.pay_status" active-text="是" inactive-text="否" :active-value="1"
                            :inactive-value="0" />

                    </el-form-item>
                    <el-form-item label="配送方式:" prop="fare_type">
                        <el-checkbox-group v-model="editForm.fare_type" @change="fareTypeChange">
                          <el-checkbox label="1">物流配送</el-checkbox>
                          <el-checkbox label="2">商家配送</el-checkbox>
                          <el-checkbox label="3">到店自提</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存更改</el-button>
                    </el-form-item>
                </el-form>

            </el-card>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";


        export default {
            name: "SysStoreConf",
            components: {},
            data() {
                return {
                    table: {
                        url: '/store/StoreConf/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    editRules: { // 表单验证规则


                        fare_type: [{
                            required: true,
                            message: '请输入运费类型',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {
                this.edit();
            },
            methods: {
                fareTypeChange(){
                    
                },

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit() {
                    this.$http.get('/store/StoreConf/info?id=1').then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                res.data.data.fare_type = res.data.data.fare_type.split(",");
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/store/StoreConf/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的商成配置吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/store/StoreConf/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/StoreConf/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/store/StoreConf/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },


                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/store/StoreConf/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>